import { Component } from '@angular/core';

@Component({
  selector: 'app-update-shopkeeper-success',
  templateUrl: './update-shopkeeper-success.component.html',
  styleUrls: ['./update-shopkeeper-success.component.scss'],
})
export class UpdateShopkeeperSuccessComponent {}
